import * as React from 'react';
import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import { useHistory } from 'react-router-dom';

export const drawerWidth = 240;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);


export function MainDrawer({open, toggleDrawer}){

  const history = useHistory();
  const gotoPage = (url) => () => history.push(url);
  
  return (<>
    <Drawer variant="permanent" open={open}  className="no-print">
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List>
            <ListItem button onClick={gotoPage("/")}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
                <ListItemText primary="Inicio" />
            </ListItem>
            <ListItem button onClick={gotoPage("/calcula-rating")}>
              <ListItemIcon>
                <CalculateIcon />
              </ListItemIcon>
                <ListItemText primary="Calculadora" />
            </ListItem>
            <ListItem button  onClick={gotoPage("/comparaciones")} >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Comparaciones" />
            </ListItem>
          </List>
        </Drawer>
  </>)
}